//////LIBRARY//////
import React, { useEffect, useState, Fragment, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useHistory, Link } from 'react-router-dom'
import _, { map, cloneDeep, isUndefined, isEmpty, find, replace } from 'lodash'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { languagesActionCreators, usersManagerActionCreators } from '../../../store/actions'
import Button from '../../../components/Ui/Buttons'
import ToggleInput from '../../../components/Ui/ToggleInput'
import Tooltip from '../../../components/Tooltip/Tooltip'
import Modals from '../../../components/Modals'
import { useRouteMatch } from 'react-router'
import { uriList } from '../../../routings/settings/RouteList'
import theme from '../../../theme/theme'
import RolesManager from '../../RolesManager'
import TagsManager from '../../TagsManager'
import userPrivileges from '../../../constants/PrivilegesList'
import {
	FormInfoWrapper,
	InputWrapper,
	InputLogin,
	SelectInput,
	SelectInputWrapper,
	ErrorInputMsg,
	LabelText,
	PageWrapperPart,
	PageWrapperPartHandler,
	PageWrapperLinks,
	PageWrapperActions,
	PageWrapperActionPrevPage,
	PageWrapperActionReset,
	PageWrapperActionValidate,
	ToggleShortcutWrapper,
	TextModal,
	OptionCustom,
	SelectInputCustom,
} from '../../../theme/GlobalCss'
import TooltipHelp from '../../../components/TooltipHelp'
import StringFormatter from '../../../helpers/StringFormatter'
//////ASSETS//////
import Validation from '../../../assets/icones/global/check.svg'
import Cancel from '../../../assets/icones/global/close-white.svg'
import TagEmptyIcon from '../../../assets/icones/global/info-big-blue.svg'
import LabelIcon from '../../../assets/icones/global/thumb-black.svg'

//////STYLED//////
const UsersManagerDetailWrapper = styled.div`
	position: relative;
`
const ButtonWrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	height: 45px;
`
const TagEmptyWarningWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	color: ${(props) => props.theme.colors.primary};
	& > span {
		max-width: 310px;
		font-size: ${(props) => props.theme.font.fs};
	}
`
const TagEmptyWarningIcon = styled.img`
	width: 32px;
	height: 32px;
	margin-right: 20px;
`
const LabelTextTag = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& > *:first-child {
		margin-right: 10px;
		width: 112px;
	}
`
const LabelTextTagCustom = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& > :first-child {
		margin-right: 10px;
	}
`
const TagList = styled.span`
	font-style: italic;
`
const PrivateTagIcon = styled.img`
	height: 15px;
	width: auto;
	margin-right: 5px;
`
const LabelPrivateTagWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`
//////STYLED//////

const UsersManagerDetail = () => {
	const [authorizeActions, setAuthorizeActions] = useState(false)

	const match = useRouteMatch()

	let history = useHistory()

	const [isUpdate, setIsUpdate] = useState(false)
	const [idCompanySelected, setCompanySelected] = useState()
	const [showModal, setShowModal] = useState(false)
	const [showModalRoles, setShowModalRoles] = useState(false)
	const [showModalTags, setShowModalTags] = useState(false)
	const [row, setRow] = useState({})
	const [roleRender, setRoleRender] = useState('')
	const [stateDefaultValues, setStateDefaultValues] = useState({
		lastName: '',
		firstName: '',
		idPreferedLanguage: 2,
		phoneNumber: '',
		email: '',
		userName: '',
		enabled: true,
		idRole: 0,
		idCompany: 0,
		idCompanyTyped: 0,
	})
	const [userEnabled, setUserEnabled] = useState(false)

	const { user, translations, userDetailForm, languagesList, userDetail, idCurrentUser, idCurrentCompany } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			usersManager: state.usersManager,
			languagesList: state.languages.items,
			userDetail: state.userDetail,
			userDetailForm: state.userDetail.items,
			idCurrentUser: state.user.identity.id,
			idCurrentCompany: state.user.identity.company.id,
			//idCurrentCompanyTyped: state.user.identity.idCompanyTyped
		}),
		shallowEqual
	)

	const actionsUserManager = bindActionCreators(usersManagerActionCreators, useDispatch())
	const actionsLanguages = bindActionCreators(languagesActionCreators, useDispatch())

	const getMyAccount = () => {
		// Is used to set roles, which should change later
		actionsUserManager.getUserDetail(idCurrentUser)
	}

	const getUserDetail = (idUser) => {
		actionsUserManager.getUserDetail(idUser)
	}

	/////////////////////////////// HANDLER //////////////////////////////////////

	const onSubmit = (data) => {
		let datas = cloneDeep(data)
		//datas.kiosks = userKioskSelected
		datas.kiosks = [idCurrentCompany]
		datas.enabled = userEnabled
		const idUser = match.params.id
		// Note : datas.idCompany is undefined on update, but it seems it isn't required on request

		isUpdate ? actionsUserManager.updateUserDetail(datas, idUser) : actionsUserManager.postUserCreate(datas)
	}

	const resetPasswordHandler = () => {
		const idUser = match.params.id
		actionsUserManager.UserDetailResetPassword(idUser)
	}

	const { register, handleSubmit, watch, errors, setValue, getValues, control, reset } = useForm({
		defaultValues: stateDefaultValues,
	})

	const handleRedirect = () => {
		history.push(`${uriList.users}${uriList.usersManager}`)
	}

	const handleModal = (dataRow) => {
		setRow({ ...dataRow })
		setShowModal((prevState) => !prevState)
	}

	const handleModalRoles = (dataRow) => {
		setShowModalRoles((prevState) => !prevState)
	}

	const handleModalTags = (dataRow) => {
		setShowModalTags((prevState) => !prevState)
	}

	const deleteUserHandler = (scope) => {
		const redirectRequest = true
		actionsUserManager.deleteAdminUser(row.id, scope, redirectRequest)
		handleModal()
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (match.url === `${uriList.users}${uriList.usersManager}${uriList.usersManagerEdit}/${match.params.id}`) setIsUpdate(true)
		setAuthorizeActions(true)
	}, [])

	useEffect(() => {
		if (isEmpty(translations)) return
		if (authorizeActions) {
			isUpdate ? getUserDetail(match.params.id) : getMyAccount()
		}
	}, [isUpdate, authorizeActions, translations])

	useEffect(() => {
		return function cleanUp() {
			// If a new role was created, we want his trad key, so a new call is needed
			actionsUserManager.resetUserDetail()
			actionsLanguages.getTranslationByLanguages(user.identity.preferedLanguage.id, 'private')
		}
	}, [])

	// When we create a role by modal, we want to call translations request anew
	const currentRolesList = useRef()

	useEffect(() => {
		if (parseInt(idCompanySelected) > 0) {
			const curRoleList = find(userDetailForm.advailableCompanies, (o) => o.id === parseInt(idCompanySelected))
			currentRolesList.current = curRoleList
		} else {
			currentRolesList.current = []
		}
	}, [idCompanySelected])

	useEffect(() => {
		const formValues = cloneDeep(userDetailForm)

		const serviceSelected = find(formValues.companyService, { isSelected: true }) || false

		if (isUpdate && !isEmpty(userDetailForm)) {
			//setInputs(userDetail.items)
			setValue('lastName', formValues.lastName)
			setValue('firstName', formValues.firstName)
			setValue('idPreferedLanguage', formValues.preferedLanguage.id)
			setValue('phoneNumber', formValues.phoneNumber)
			setValue('email', formValues.email)
			setValue('userName', formValues.login)
			setValue('idCompanyService', serviceSelected ? serviceSelected.id : '0')
			//setValue("idRole",formValues.role.id)
			setValue('enabled', formValues.enabled)
			// Only setting company value on loading edit
			if (isUndefined(idCompanySelected)) {
				setValue('idCompany', formValues.userCompany.id)
				setCompanySelected(formValues.userCompany.id)
			} else {
				// Otherwise, default behaviour
				setValue('idCompany', idCompanySelected)
			}
			setValue('idCompanyTyped', formValues.userCompany.companyTypeds.id)
			setUserEnabled(formValues.enabled)
			setStateDefaultValues(getValues())
		} /*else{
            setCompanySelected(idCurrentCompany)
        }*/
		//setCompanySelected(userDetail.items.userCompany.id)
		setRoleRender(
			<>
				<SelectInputWrapper>
					<SelectInputCustom
						width="208"
						name="idRole"
						defaultValues=""
						placeholder={theme.text.colors.primary}
						ref={register({
							required: {
								value: true,
								message: translations['common__text__requiredField'],
							},
							validate: (value) => value > 0 || translations['common__text__requiredField'],
						})}
					>
						<OptionCustom value="0" hidden>
							{translations['page__userDetail__admin__userSheet_form_role_prefilled']}
						</OptionCustom>
						{map(userDetail.items.advailableCompanies, (elem, id) => {
							return (
								elem.id === parseInt(idCompanySelected) &&
								map(elem.roles, (role, subid) => {
									return (
										<OptionCustom key={subid} value={role.id} target={true}>
											{role.label}
										</OptionCustom>
									)
								})
							)
						})}
					</SelectInputCustom>
				</SelectInputWrapper>
				{errors.idRole && <ErrorInputMsg>{errors.idRole.message}</ErrorInputMsg>}
			</>
		)
	}, [userDetailForm, idCompanySelected, errors])

	// Auto select newly created role
	useEffect(() => {
		// We must have selected a company
		if (parseInt(idCompanySelected) > 0) {
			const curCompany = find(userDetailForm?.advailableCompanies, (o) => o.id === parseInt(idCompanySelected))
			if (curCompany.roles.length > currentRolesList.current?.roles?.length) {
				setValue('idRole', _.last(curCompany.roles).id)
			}
		}
	}, [currentRolesList.current, userDetailForm?.advailableCompanies, roleRender])

	useEffect(() => {
		if (roleRender !== '' && idCompanySelected && userDetailForm?.role?.id > 0 && getValues('idRole') == '0') {
			setValue('idRole', userDetailForm.role.id)
		}
	}, [roleRender])

	const [lastName, setLastName] = useState('')
	const [firstName, setFirstName] = useState('')

	useEffect(() => {
		if (!isUndefined(userDetail.items.lastName) || !isUndefined(userDetail.items.firstName)) {
			setLastName(`<span style="color: ${theme.colors.primary}" >${userDetail.items.lastName}</span>`)
			setFirstName(`<span style="color: ${theme.colors.primary}" > ${userDetail.items.firstName}</span>`)
		}
	}, [userDetail.items?.lastName, userDetail.items.firstName])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const textModal = StringFormatter.ResponseMessageParser(
		replace(translations['page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionTypeUserDetail_body'], '\\n', '<br>'),
		[lastName, firstName]
	)

	return (
		<Fragment>
			<Modals closeModalHandler={handleModalRoles} showModal={showModalRoles} minWidth={1200}>
				<RolesManager userMode={true} closeModalHandler={handleModalRoles} />
			</Modals>
			<Modals closeModalHandler={handleModalTags} showModal={showModalTags} minWidth={1200}>
				<TagsManager userMode={true} closeModalHandler={handleModalTags} />
			</Modals>

			{/* MODAL DU EDIT USER */}
			<Modals
				title={translations['page__userManagement__userTable_modalAction_button_deleteUser']}
				closeModalHandler={handleModal}
				showModal={showModal}
				level="error"
				icon={true}
			>
				<TextModal>
					<p style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: textModal }}></p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleModal}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => deleteUserHandler('delete')}
						text={translations['common__text__validate']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerDetailWrapper>
				<PageWrapperLinks>
					<Button
						goBack
						weight="bold"
						//actionHandler={ () => {history.push(`${uriList.users}${uriList.usersManager}`)} }
						actionHandler={() => handleRedirect()}
						text={translations['common__text__previousPage']}
					/>
				</PageWrapperLinks>
				<form onSubmit={handleSubmit(onSubmit)}>
					<PageWrapperActions>
						<Tooltip tooltipId={'userDetailSubmit'} translationsKey={'tooltip__admin__global__save'}>
							<PageWrapperActionValidate type="submit" />
						</Tooltip>
						<Tooltip tooltipId={'userDetailClose'} translationsKey={'tooltip__admin__global__cancel'}>
							<PageWrapperActionPrevPage onClick={() => history.push(`${uriList.users}${uriList.usersManager}`)} />
						</Tooltip>
						<Tooltip tooltipId={'userDetailReset'} translationsKey={'tooltip__admin__global__reset'}>
							<PageWrapperActionReset onClick={() => reset(stateDefaultValues)} />
						</Tooltip>
					</PageWrapperActions>
					<PageWrapperPartHandler>
						<PageWrapperPart>
							<FormInfoWrapper password>
								<LabelText>
									{/* Langue par défaut : */}
									{translations['page__userDetail__admin__userSheet_form_defaultLanguage']}* :
								</LabelText>

								<InputWrapper>
									<SelectInputWrapper>
										<SelectInput
											width="208"
											name="idPreferedLanguage"
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
										>
											{map(languagesList, (elem, id) => {
												return (
													<option key={id} value={elem.id}>
														{elem.labelEnglish}
													</option>
												)
											})}
										</SelectInput>
									</SelectInputWrapper>
									{errors.idPreferredLanguage && <ErrorInputMsg>{errors.idPreferredLanguage.message}</ErrorInputMsg>}
								</InputWrapper>
								<LabelText>
									{/* Nom : */}
									{translations['page__userDetail__admin__userSheet_form_lastname']}* :
								</LabelText>
								<InputWrapper>
									<InputLogin
										name="lastName"
										type="text"
										// placeholder="Nom"
										placeholder={translations['page__userDetail__admin__userSheet_form_lastname_prefilled']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 150,
												message: '',
											},
										})}
									/>
									{errors.lastName && <ErrorInputMsg>{errors.lastName.message}</ErrorInputMsg>}
								</InputWrapper>

								<LabelText>
									{/* Prénom : */}
									{`${translations['page__userDetail__admin__userSheet_form_firstname']}`}* :
								</LabelText>
								<InputWrapper>
									<InputLogin
										name="firstName"
										type="text"
										placeholder={translations['page__userDetail__admin__userSheet_form_firstname_prefilled']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 150,
												message: '',
											},
										})}
									/>
									{errors.firstName && <ErrorInputMsg>{errors.firstName.message}</ErrorInputMsg>}
								</InputWrapper>
								<LabelText>
									{/* Société : */}
									{translations['page__userDetail__admin__userSheet_form_company']}* :
								</LabelText>
								<InputWrapper>
									<SelectInputWrapper ref={currentRolesList} isDisabled={true}>
										<SelectInputCustom
											name="idCompany"
											width="208"
											onChange={() => setCompanySelected(getValues('idCompany'))}
											disabled={isUpdate}
											defaultValues=""
											className={watch('idCompany') > 0 ? 'active' : ''}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												validate: (value) => value > 0 || translations['common__text__requiredField'],
											})}
										>
											<OptionCustom value="0" hidden>
												{translations['page__userDetail__admin__userSheet_form_company_prefilled']}
											</OptionCustom>
											{map(userDetail.items.advailableCompanies, (elem, id) => {
												return (
													<OptionCustom key={id} value={elem.id} target={true}>
														{elem.labelToDisplay}
													</OptionCustom>
												)
											})}
										</SelectInputCustom>
									</SelectInputWrapper>
									{errors.idCompany && <ErrorInputMsg>{errors.idCompany.message}</ErrorInputMsg>}
								</InputWrapper>
								<LabelText>
									{/* Division : */}
									{translations['page__userDetail__admin__userSheet_form_division']}* :
								</LabelText>
								{
									<InputWrapper>
										<SelectInputWrapper>
											<SelectInputCustom
												name="idCompanyTyped"
												width="208"
												defaultValues=""
												className={watch('idCompanyTyped') > 0 ? 'active' : ''}
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
											>
												<OptionCustom value="0">
													{translations['page__userDetail__admin__userSheet_form_division_prefilled']}
												</OptionCustom>
												{map(userDetail.items.advailableCompanies, (elem, id) => {
													return (
														elem.id === parseInt(idCompanySelected) &&
														map(elem.companyTypeds, (companyTyped, subid) => (
															<OptionCustom key={subid} value={companyTyped.id} target={true}>
																{translations[companyTyped.translationKey]}
															</OptionCustom>
														))
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.idCompanyTyped && <ErrorInputMsg>{errors.idCompanyTyped.message}</ErrorInputMsg>}
									</InputWrapper>
								}
								<LabelText>
									{/* Service : */}
									{translations['page__userDetail__userSheet_form_service']} :
								</LabelText>
								{
									<InputWrapper>
										<SelectInputWrapper>
											<SelectInputCustom
												name="idCompanyService"
												width="208"
												defaultValues=""
												className={watch('idCompanyService') > 0 ? 'active' : ''}
												ref={register({})}
											>
												<OptionCustom value="" hidden>
													{translations['page__userDetail__userSheet_form_service_doubleDot']}
												</OptionCustom>
												{map(userDetail.items.companyService, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} target={true}>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.idCompanyService && <ErrorInputMsg>{errors.idCompanyService.message}</ErrorInputMsg>}
									</InputWrapper>
								}
								<TooltipHelp content={'tooltipHelp__admin__modal__body__userPreference__SMS'} childrenPos={1}>
									<LabelText>
										{/* Téléphone : */}
										{translations['page__userDetail__admin__userSheet_form_phone']} :
									</LabelText>
								</TooltipHelp>
								<InputWrapper>
									<InputLogin
										name="phoneNumber"
										type="tel"
										placeholder={translations['page__userDetail__admin__userSheet_form_phone_prefilled']}
										ref={register({
											required: {
												value: false,
												message: translations['common__text__requiredField'],
											},
										})}
									/>
									{errors.phoneNumber && <ErrorInputMsg>{errors.phoneNumber.message}</ErrorInputMsg>}
								</InputWrapper>
								<LabelText>
									{/* Email : */}
									{translations['page__userDetail__admin__userSheet_form_email']}* :
								</LabelText>
								<InputWrapper>
									<InputLogin
										type="text"
										name="email"
										placeholder={translations['page__userDetail__admin__userSheet_form_email_prefilled']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 150,
												message: `150 ${translations['common__text__charMax']}`,
											},
											pattern: {
												value: RegExp(
													/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
												),
												message: translations['common__text__invalidEmail'],
											},
										})}
									/>
									{errors.email && <ErrorInputMsg>{errors.email.message}</ErrorInputMsg>}
								</InputWrapper>
								{/* User Role : */}
								<LabelText>{translations['page__userDetail__admin__userSheet_form_role']}* :</LabelText>
								<InputWrapper>{roleRender}</InputWrapper>
								{idCompanySelected &&
									parseInt(idCompanySelected) === user?.identity?.company.id &&
									!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.view[17])) && (
										<Link onClick={() => handleModalRoles()}>
											{translations['page__userDetail__admin__userSheet_form_role_link']}
										</Link>
									)}
								<div></div>
								{/* User Kiosks : */}
								{/* <LabelTextKiosks>
                        {translations['page__userDetail__admin__userSheet_form_kioskSelected']}
                    </LabelTextKiosks>
                        <KioskCheckBoxWrapper>
                            {
                                map(userDetail.items.kiosks, (elem, id ) => (
                                    <LabelCheckbox
                                        key={ id }
                                    >
                                        <InputLogin
                                            name='kiosks'
                                            component="input"
                                            type="checkbox"
                                            value={ elem.id }
                                            // disabled last input checked
                                            disabled={
                                                values.kiosks.length === 1 &&
                                                values.kiosks[0] === elem.id
                                            }
                                        />{ ' ' }
                                        { `${ elem.description } - ${ elem.model }` }
                                    </LabelCheckbox>
                                ))
                            }
                            {meta.error && meta.touched && <ErrorInputMsg>{meta.error}</ErrorInputMsg>}
                        </KioskCheckBoxWrapper>
                     */}
							</FormInfoWrapper>
						</PageWrapperPart>
						<PageWrapperPart>
							<FormInfoWrapper password>
								<ToggleShortcutWrapper>
									<TooltipHelp content={'tooltipHelp__admin__modal__body__userDetail__enable'} childrenPos={1}>
										<LabelText>{translations['page__userDetail__admin__userSheet_form_activeDesactive']} :</LabelText>
									</TooltipHelp>
									<Controller
										control={control}
										name="enabled"
										as={ToggleInput}
										checked={userEnabled}
										onChangeHandler={() => {
											setUserEnabled((prevState) => !prevState)
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev
										labelNext
									/>
								</ToggleShortcutWrapper>
								<div></div>
								{idCurrentUser !== userDetail.items.id && (
									<Fragment>
										<Link onClick={() => handleModal(userDetail.items)}>
											{translations['page__userDetail__admin__userSheet_form_delete']}
										</Link>
										<div></div>
									</Fragment>
								)}
								<LabelText>{translations['page__userDetail__admin__userSheet_form_login']}* :</LabelText>
								<InputWrapper>
									<InputLogin
										name="userName"
										type="text"
										placeholder={translations['page__userDetail__admin__userSheet_form_login_prefilled']}
										disabled={isUpdate}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 150,
												message: `150 ${translations['common__text__charMax']}`,
											},
										})}
									/>
									{errors.userName && <ErrorInputMsg>{errors.userName.message}</ErrorInputMsg>}
								</InputWrapper>
								{idCurrentUser !== userDetail.items.id &&
									!isUndefined(
										find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.buttonAction[0])
									) && (
										<Fragment>
											<LabelText>{translations['page__userDetail__admin__userSheet_form_password']} :</LabelText>
											<Link onClick={() => resetPasswordHandler()} style={{ textDecoration: 'none' }}>
												<Button
													height={56}
													bgColor={theme.colors.cancel}
													text={translations['page__userDetail__admin__userSheet_form_button_renewPassword']}
												/>
											</Link>
										</Fragment>
									)}
							</FormInfoWrapper>
						</PageWrapperPart>
						{isUpdate && !isUndefined(userDetail.items.publicTags) && !isUndefined(userDetail.items.privateTags) && (
							<PageWrapperPart>
								<FormInfoWrapper>
									<LabelTextTag>
										<TooltipHelp content={'tooltipHelp__admin__modal__body__userDetail__publicTag'} childrenPos={2}>
											<LabelText>{translations['page__userDetail__admin__userSheet_form_public_tag']} :</LabelText>
										</TooltipHelp>
										<TagList>
											{!isEmpty(userDetail.items.publicTags.tags)
												? _.map(userDetail.items.publicTags.tags, 'name').join(' | ')
												: translations['page__userDetail__admin__userSheet_form_empty_tag']}
										</TagList>
									</LabelTextTag>
									<div></div>

									<LabelTextTagCustom>
										<TooltipHelp content={'tooltipHelp__admin__modal__body__userDetail__privateTag'} childrenPos={2}>
											<LabelPrivateTagWrapper>
												<PrivateTagIcon src={LabelIcon} />
												<LabelText>{translations['page__userDetail__admin__userSheet_form_private_tag']} :</LabelText>
											</LabelPrivateTagWrapper>
										</TooltipHelp>

										<TagList>
											{!isEmpty(userDetail.items.privateTags.tags)
												? _.map(userDetail.items.privateTags.tags, 'name').join(' | ')
												: translations['page__userDetail__admin__userSheet_form_empty_tag']}
										</TagList>
									</LabelTextTagCustom>
									<div></div>
									{isEmpty(userDetail.items.publicTags.tags) && isEmpty(userDetail.items.privateTags.tags) && (
										<Fragment>
											<TagEmptyWarningWrapper>
												<TagEmptyWarningIcon src={TagEmptyIcon} />
												<span>{translations['page__userDetail__admin__userSheet_form_empty_tag_message']}</span>
											</TagEmptyWarningWrapper>
											<div></div>
										</Fragment>
									)}
									{idCompanySelected &&
										parseInt(idCompanySelected) === user?.identity?.company.id &&
										!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.view[18])) && (
											<Link onClick={() => handleModalTags()}>
												{translations['page__userDetail__admin__userSheet_form_tag_link']}
											</Link>
										)}
									<div></div>
								</FormInfoWrapper>
							</PageWrapperPart>
						)}
					</PageWrapperPartHandler>
				</form>
			</UsersManagerDetailWrapper>
		</Fragment>
	)
}

UsersManagerDetail.propTypes = {}

UsersManagerDetail.defaultPropTypes = {}

export default UsersManagerDetail
